import moment from "moment";
import { createCrudActions } from "../utils/crudGenerator";

const formatOffers = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: item._id, // Offers don't have a name field, use _id as label
    value: item._id,
    // Keep date as ISO string for Redux storage
    date: item.date ? moment(item.date).toISOString() : null,
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchOffers,
  create: createOffer,
  update: updateOffer,
  delete: deleteOffers,
} = createCrudActions("OFFER", "Oferta", formatOffers);
